import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { BRAND } from '../constants/brand';
import { TEMA_DEFAULT, TEMA_MOSTEN } from '../constants/temas';

@Injectable({
  providedIn: 'root'
})
export class TemaService {
  constructor(@Inject(DOCUMENT) private document: Document) {}

  aplicarTemaDefault(): void {
    const root = this.document.documentElement;
    const tema = BRAND.isMosten ? TEMA_MOSTEN : TEMA_DEFAULT;

    Object.entries(tema).forEach(([variavel, valor]) => {
      root.style.setProperty(variavel, valor);
    });

    this.aplicarFavicon();
  }

  private aplicarFavicon(): void {
    const link = this.document.querySelector("link[rel~='icon']") as HTMLLinkElement | null;
    if (link) {
      link.href = BRAND.favicon;
    }
  }

  aplicarCustomizacao(): void {
    // criar uma forma de aplicar a customização via interface
  }
}
